import { useState, useEffect } from 'react';
import { actions as authActions } from "../modules/Auth/_redux/authRedux";

const useTabManagement = (dispatch, setOpenMultiTabDialog) => {

  const generateTabId = () => Date.now().toString(36);

  const isPrimaryTab = () => localStorage.getItem('activeTabID') === window.currentTabId;

  const handleUseThisTab = (id = null) => {
    if (!id) {
      const tabId = generateTabId();
      const activeTabID = localStorage.getItem('activeTabID');
      if (!window.currentTabId) {
        window.currentTabId = tabId;
      }
      if (!activeTabID) {
        localStorage.setItem('activeTabID', tabId);
        dispatch(authActions.checkDuplicatedTab({ is_duplicated_tab: false }));
      }
      dispatch(authActions.checkDuplicatedTab({ is_duplicated_tab: !isPrimaryTab() }));
    } else {
      localStorage.setItem('activeTabID', id);
      window.currentTabId = id;
      window.location.reload();
      // dispatch(authActions.checkDuplicatedTab({ is_duplicated_tab: !isPrimaryTab() }));
    }
  };

  useEffect(() => {
    handleUseThisTab();
    const storageEventListener = (event) => {
      if (event.storageArea === localStorage && event.key === 'activeTabID') {
        if (event.oldValue == window.currentTabId) {
          dispatch(authActions.checkDuplicatedTab({ is_duplicated_tab: !isPrimaryTab() }));
        }
      }
    };
    window.addEventListener('storage', storageEventListener);

    const unloadEventListener = () => {
      if (isPrimaryTab()) {
        localStorage.removeItem('activeTabID');
      }
    };
    window.addEventListener('unload', unloadEventListener);

    return () => {
      window.removeEventListener('storage', storageEventListener);
      window.removeEventListener('unload', unloadEventListener);
    };
  }, []);

  const makeCurrentTabPrimary = (id) => {
    handleUseThisTab(id);
    setOpenMultiTabDialog(false); // Close the dialog
  };

  return {
    makeCurrentTabPrimary,
  };
};

export default useTabManagement;
